import { IUpdateItemProcessoFatorUseCase } from "../../../presentation/useCases/update/updade_item_processo_fator_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateProcessoFatorUseCase


export class UpdateItemProcessoFatorUseCase implements IUpdateItemProcessoFatorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateItemProcessoFator(IdItemProcessoFator: number, IdItemProcesso: number | null, FatorRisco: string | null, IternoExterno: string | null, Consequencia: string | null, Oportunidade: string | null, Acao: string | null, Acompanhamento: string | null, Ocorrencia: number | null, Impacto: number | null, RiscoOportunidade: number | null): Promise<void> {
    await this.repository.updateItemProcessoFator(IdItemProcessoFator, IdItemProcesso, FatorRisco, IternoExterno, Consequencia, Oportunidade, Acao, Acompanhamento, Ocorrencia, Impacto, RiscoOportunidade);
  }
}
